import React, { useState } from "react";
import "./style.css";

const Blog = () => {
  const [loading, setLoading] = useState(true);

  const handleIframeLoad = () => {
    setLoading(false);
  };

  return (
    <div className="blog_container" style={{ height: "100%" }}>
      <div className="blog_header">
        <h1 className="pageHeading">Blogs</h1>
      </div>
      <div style={{ marginTop: "20px", height: "90%" }}>
        {loading && (
          <div className="loadingBox">
            <p>Loading Strapi...</p>
          </div>
        )}
        <iframe
          src="https://justicia.decotechs.xyz/admin"
          style={{ width: "100%", height: "100%", border: "none" }}
          onLoad={handleIframeLoad}
        ></iframe>
      </div>
    </div>
  );
};

export default Blog;
